class MailAccountRequestDto {
  /** 邮件地址 */
  address = "";

  /** 编号 */
  code = "";

  /** imap地址 */
  imap = "";

  /** imap端口 */
  imapPort = undefined;

  /** 是否启用ssl 0:否 1:是 */
  imapSsl = undefined;

  /** 名称 */
  name = "";

  /** 邮件密码 */
  password = "";

  /** 应用范围 */
  scope = "ALL";

  /** smtp地址 */
  smtp = "";

  /** smtp端口 */
  smtpPort = undefined;

  /** 是否启用ssl 0:否 1:是 */
  smtpSsl = undefined;

  /** 状态 1:启用 2:停用 */
  status = undefined;
}

class MailMessageDto {
  /** 应用 */
  appScopeEnum = "ALL";

  /** 帐号code */
  code = "";

  /** 收件内容 */
  content = "";

  /** messageId */
  messageId = "";

  /** 附件 */
  multipartDtoList = [];

  /** 收件人 */
  receiver = "";

  /** 收件地址 */
  receiverAddress = "";

  /** 主题 */
  subject = "";

  /** uid */
  uid = undefined;
}

class MailMessageEntity {
  /** 收件内容 */
  content = "";

  /** 发件人 */
  from = "";

  /** 发件地址 */
  fromAddress = "";

  /** messageId */
  messageId = "";

  /** 附件 */
  multipart = [];

  /** 收件时间 */
  receivedDate = "";

  /** 收件人 */
  receiver = "";

  /** 收件地址 */
  receiverAddress = "";

  /** 发送时间 */
  sentDate = "";

  /** 主题 */
  subject = "";

  /** type html/plain */
  type = "HTML";

  /** uid */
  uid = undefined;
}

class MailMessageMultipartDto {
  /** 内嵌ID */
  contentId = "";

  /** 文件名 */
  fileName = "";

  /** host路径 */
  host = "";

  /** 相对路径 */
  path = "";
}

class MailMessageMultipartEntity {
  /** 内嵌ID */
  contentId = "";

  /** 文件名 */
  fileName = "";

  /** host路径 */
  host = "";

  /** 相对路径 */
  path = "";
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new MailMessageDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

export const mail = {
  MailAccountRequestDto,
  MailMessageDto,
  MailMessageEntity,
  MailMessageMultipartDto,
  MailMessageMultipartEntity,
  Response,
  ResponseDto,
};
